import React, { useEffect, useState } from "react";
import axios from "axios";
import { KENO_API as API, gameHeaders } from "./fairnessApi";
import { GameBetDetails } from "./GameBetDetails";
import { BetHistoryToolbar } from "./BetHistoryToolbar";
import { BetHistoryTable } from "./BetHistoryTable";
import { PublicBetDetails } from "./PublicBetDetails";
import { PlayerProfileDialog } from '../chat/PlayerProfileDialog';
import "./betHistory.css";

export const KenoBetHistory = ({ game }) => {
  const [tab, setTab] = useState("my");
  const [limit, setLimit] = useState(10);
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [detail, setDetail] = useState(null);
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    setDetail(null); setProfile(null); setBets([]); setError("");
  }, [game.owner, tab]);
  useEffect(() => {
    let active = true;
    const load = async () => {
      if (tab === "my" && game.demo) { setBets([...game.wallet.rounds].reverse().slice(0, limit)); setError(""); setLoading(false); return; }
      setLoading(true);
      try {
        const { data } = await axios.get(`${API}/keno/history${tab === "all" ? "/all" : ""}?limit=${limit}`, { headers: tab === "all" ? {} : gameHeaders(false) });
        if (active) { setBets(data.bets); setError(""); }
      } catch { if (active) setError("Unable to load bet history."); }
      finally { if (active) setLoading(false); }
    };
    load();
    const timer = setInterval(load, 5000);
    return () => { active = false; clearInterval(timer); };
  }, [tab, limit, game.demo, game.owner, game.wallet.rounds, game.wallet.ghost]);
  // Filter at render time, including fresh API responses, until Plinko actually lands.
  const visibleBets = bets.filter((round) => !game.hiddenHistoryIds?.has(round.request_id));
  return <section className="keno-bet-history" data-testid="keno-bet-history" aria-label="Bet history">
    <BetHistoryToolbar tab={tab} setTab={setTab} limit={limit} setLimit={setLimit} game={game} />
    <div id="keno-history-panel" role="tabpanel" aria-labelledby={`keno-history-tab-${tab}`} data-testid="keno-history-panel">
      <BetHistoryTable bets={visibleBets} publicView={tab === 'all'} onDetail={setDetail} onProfile={(username, trigger) => setProfile({ username, trigger })} loading={loading} />
      {!visibleBets.length && <p className="keno-history-empty" role="status" data-testid="keno-history-empty">{loading ? "Loading bets…" : error ? "Bet history unavailable" : "No bets yet"}</p>}
      {error && <p role="alert" data-testid="keno-history-error" className="keno-error">{error}</p>}
    </div>
    {detail && (detail.public_view ? <PublicBetDetails key={detail.public_id} publicId={detail.public_id} game={game} onClose={() => setDetail(null)} /> : <GameBetDetails key={detail.request_id} round={detail} game={game} onClose={() => setDetail(null)} />)}
    {profile && <PlayerProfileDialog username={profile.username} onClose={() => setProfile(null)} returnFocus={() => profile.trigger?.isConnected && profile.trigger.focus({ preventScroll: true })} />}
  </section>;
};